import * as React from "react";
import { TappableButton } from "src/sharedComponents/common/tappable";

export interface ButtonProps {
    label: string;
    disabled?: boolean;
    type?: string;

    onClick?: () => void;
}

export class Button extends React.Component<ButtonProps> {
    render() {
        const { label, disabled, type } = this.props;

        const className = disabled ? `button button--disabled` : "button";

        return (
            <TappableButton type={type} disabled={disabled} className={className} onClick={this.onClick}>
                {label}
            </TappableButton>
        );
    }

    onClick = () => {
        if (this.props.onClick) {
            this.props.onClick();
        }
    };
}
